<template>
  <div class="black--text">
    <validation-observer ref="productForm">
      <v-row
        dense
        class="my-5"
      >
        <v-col cols="12">
          <div class="subtitle-1">
            Product Information
          </div>
        </v-col>

        <v-col
          cols="6"
          sm="4"
        >
          <validation-provider
            v-slot="{ errors }"
            rules="required"
            name="Product Name"
          >
            <v-text-field
              v-model="formValues.description"
              label="Product Name"
              :error="!!errors.length"
              :error-messages="errors"
            />
          </validation-provider>
        </v-col>

        <v-col
          cols="6"
          sm="4"
        >
          <validation-provider
            v-slot="{ errors }"
            rules="required"
            name="Retailer Code"
          >
            <v-text-field
              v-model="formValues.retailer_code"
              :disabled="!!defaultFormValues.retailer_code"
              label="Retailer Code"
              :error="!!errors.length"
              :error-messages="errors"
            />
          </validation-provider>
        </v-col>

        <v-col
          cols="6"
          sm="4"
        >
          <validation-provider
            v-slot="{ errors }"
            rules="required"
            name="Vender Reference Code"
          >
            <v-text-field
              v-model="formValues.vendor_reference_code"
              :disabled="!!defaultFormValues.vendor_reference_code"
              label="Vender Reference Code"
              :error="!!errors.length"
              :error-messages="errors"
            />
          </validation-provider>
        </v-col>

        <v-col
          cols="6"
          sm="4"
        >
          <validation-provider
            v-slot="{ errors }"
            rules="required|positive"
            name="Units on Pallet"
          >
            <v-text-field
              v-model="formValues.units_on_pallet"
              type="number"
              label="Units on Pallet"
              :error="!!errors.length"
              :error-messages="errors"
            />
          </validation-provider>
        </v-col>

        <v-col
          cols="6"
          sm="4"
        >
          <v-checkbox
            v-model="formValues.is_topable"
            label="Is Topable ?"
          />
        </v-col>

        <v-col
          cols="6"
          sm="4"
        >
          <v-checkbox
            v-model="formValues.is_topper"
            label="Is Topper ?"
          />
        </v-col>
      </v-row>

      <v-row
        dense
        class="my-5"
      >
        <v-col cols="12">
          <div class="subtitle-1">
            Product Weight
          </div>
        </v-col>
        <v-col
          cols="6"
          sm="3"
        >
          <v-select
            v-model="formValues.weightUnit"
            label="Weight type"
            :items="weightUnits"
          />
        </v-col>
        <v-col
          cols="6"
          sm="3"
        >
          <validation-provider
            v-slot="{ errors }"
            rules="required|positive"
            name="Weight"
          >
            <v-text-field
              v-model="formValues.weight"
              type="number"
              label="Weight"
              :error="!!errors.length"
              :error-messages="errors"
            />
          </validation-provider>
        </v-col>
      </v-row>

      <v-row
        dense
        class="my-5"
      >
        <v-col cols="12">
          <div class="subtitle-1">
            Pallet Information
          </div>
        </v-col>

        <v-col
          cols="6"
          sm="4"
        >
          <validation-provider
            v-slot="{ errors }"
            rules="required"
            name="Pallet Name"
          >
            <v-text-field
              v-model="formValues.palletName"
              label="Pallet Name"
              :error="!!errors.length"
              :error-messages="errors"
            />
          </validation-provider>
        </v-col>
      </v-row>

      <v-row
        dense
        class="my-5"
      >
        <v-col cols="12">
          <div class="subtitle-1">
            Pallet Weight
          </div>
        </v-col>

        <v-col
          cols="6"
          sm="3"
        >
          <v-select
            v-model="formValues.palletWeightUnit"
            label="Weight type"
            :items="weightUnits"
          />
        </v-col>

        <v-col
          cols="6"
          sm="3"
        >
          <validation-provider
            v-slot="{ errors }"
            rules="required|positive"
            name="Pallet Weight"
          >
            <v-text-field
              v-model="formValues.palletWeight"
              type="number"
              label="Weight"
              :error="!!errors.length"
              :error-messages="errors"
            />
          </validation-provider>
        </v-col>

        <v-col
          cols="6"
          sm="3"
        >
          <validation-provider
            v-slot="{ errors }"
            rules="required|positive"
            name="Pallet Price"
          >
            <v-text-field
              v-model="formValues.palletPrice"
              prefix="£"
              type="number"
              label="Pallet Price"
              :error="!!errors.length"
              :error-messages="errors"
            />
          </validation-provider>
        </v-col>

        <v-col
          cols="6"
          sm="3"
        >
          <v-checkbox
            v-model="formValues.isPalletStackable"
            label="Is Stackable ?"
          />
        </v-col>
      </v-row>

      <v-row
        dense
        class="my-5"
      >
        <v-col cols="12">
          <div class="subtitle-1">
            Pallet Dimensions
          </div>
        </v-col>
        <v-col
          cols="6"
          sm="3"
        >
          <v-select
            v-model="formValues.measurementUnit"
            label="Measurement Unit"
            :items="dimensionUnits"
          />
        </v-col>
        <v-col
          cols="6"
          sm="3"
        >
          <validation-provider
            v-slot="{ errors }"
            rules="required|positive"
            name="Width"
          >
            <v-text-field
              v-model="formValues.width"
              type="number"
              label="Width"
              :error="!!errors.length"
              :error-messages="errors"
            />
          </validation-provider>
        </v-col>
        <v-col
          cols="6"
          sm="3"
        >
          <validation-provider
            v-slot="{ errors }"
            rules="required|positive"
            name="Length"
          >
            <v-text-field
              v-model="formValues.length"
              type="number"
              label="Length"
              :error="!!errors.length"
              :error-messages="errors"
            />
          </validation-provider>
        </v-col>
        <v-col
          cols="6"
          sm="3"
        >
          <validation-provider
            v-slot="{ errors }"
            rules="required|positive"
            name="Height"
          >
            <v-text-field
              v-model="formValues.height"
              type="number"
              label="Height"
              :error="!!errors.length"
              :error-messages="errors"
            />
          </validation-provider>
        </v-col>
      </v-row>
    </validation-observer>

    <v-card-actions>
      <v-spacer />
      <v-btn
        :loading="isSubmitButtonLoading"
        depressed
        color="success"
        @click="validateAndSubmitForm"
      >
        <span v-text="defaultFormValues.id ? 'Update Product': 'Add Product'" />
      </v-btn>
    </v-card-actions>
  </div>
</template>

<script>
import { products } from '@/endpoints';
import { dimensionUnits, weightUnits } from '@/constants/misc';

function getDefaultFormValues() {
  return {
    description: '',
    retailer_code: '',
    vendor_reference_code: '',
    units_on_pallet: '',
    is_topable: false,
    is_topper: false,
    weight: '',
    weightUnit: 'kg',
    palletWeightUnit: 'kg',
    palletName: '',
    isPalletStackable: false,
    palletPrice: '',
    palletWeight: '',
    measurementUnit: 'in',
    width: '',
    length: '',
    height: '',
  };
}

function constructPayload(formValues) {
  return {
    units_on_pallet: formValues.units_on_pallet,
    weight: {
      units: formValues.weightUnit,
      value: formValues.weight,
    },
    retailer_code: formValues.retailer_code,
    is_topable: formValues.is_topable,
    is_topper: formValues.is_topper,
    vendor_reference_code: formValues.vendor_reference_code,
    description: formValues.description,
    pallet: {
      name: formValues.palletName,
      is_stackable: formValues.isPalletStackable,
      pallet_price: formValues.palletPrice,
      empty_weight: {
        value: formValues.palletWeight,
        units: formValues.palletWeightUnit,
      },
      external_dimensions: {
        width: formValues.width,
        height: formValues.height,
        length: formValues.length,
        units: formValues.measurementUnit,
      },
    },
  };
}

export default {
  props: {
    defaultFormValues: {
      type: Object,
      default() {
        return getDefaultFormValues();
      },
    },
  },
  data() {
    return {
      isSubmitButtonLoading: false,
      weightUnits: Object.values(weightUnits),
      dimensionUnits: Object.values(dimensionUnits),
      formValues: { ...this.defaultFormValues },
    };
  },
  methods: {
    async validateAndSubmitForm() {
      const isFormValid = await this.$refs.productForm.validate();
      if (!isFormValid) {
        return;
      }

      this.submitForm();
    },
    submitForm() {
      if (!this.defaultFormValues.id) {
        this.addProduct(this.formValues);
      } else {
        this.updateProduct(this.formValues);
      }
    },
    addProduct(formValues) {
      this.isSubmitButtonLoading = true;
      const payload = constructPayload(formValues);
      this.axios
        .post(products, payload)
        .then(() => {
          this.$emit('added');
          this.$emit('displaySnackbar', {
            color: 'green',
            text: 'Successfully added new product',
          });
        })
        .catch(() => {
          this.$emit('displaySnackbar', {
            color: 'red',
            text: 'An error occured. Please try again',
          });
        })
        .finally(() => {
          this.isSubmitButtonLoading = false;
        });
    },
    updateProduct(formValues) {
      this.isSubmitButtonLoading = true;
      const payload = constructPayload(formValues);
      const url = `${products}${this.formValues.sku}/`;
      this.axios
        .put(url, payload)
        .then(() => {
          this.$emit('updated');
          this.$emit('displaySnackbar', {
            color: 'green',
            text: 'Successfully updated product',
          });
        })
        .catch(() => {
          this.$emit('displaySnackbar', {
            color: 'red',
            text: 'An error occured. Please try again',
          });
        })
        .finally(() => {
          this.isSubmitButtonLoading = false;
        });
    },
  },
};

</script>
